export default "__VITE_ASSET__DnrSOs5___"